module.exports = __webpack_public_path__ + "static/media/pre_2015_composite.2199fe62.jpg";